import { render, staticRenderFns } from "./MarketplaceSKUDisplay.vue?vue&type=template&id=19b901dd&scoped=true&"
import script from "./MarketplaceSKUDisplay.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSKUDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b901dd",
  null
  
)

export default component.exports